/**
 * Value Proposition Banners Slider
 * Inizializza lo slider con auto-rotation, touch support e keyboard navigation
 */
(function() {
  'use strict';

  function initVPBSlider(container, options) {
    if (!container) return;

    var opts = options || {};
    var interval = opts.delay || 5000;

    var viewport = container.querySelector('.vpb__viewport');
    var track = container.querySelector('.vpb__track');
    var items = Array.prototype.slice.call(track.querySelectorAll('.vpb__item'));
    var prev = container.querySelector('.vpb__prev');
    var next = container.querySelector('.vpb__next');
    var index = 0;
    var timer = null;

    function setItemWidths() {
      var w = viewport.offsetWidth;
      items.forEach(function(item) {
        item.style.width = w + 'px';
        item.style.minWidth = w + 'px';
      });
    }

    function goTo(i) {
      if (items.length === 0) return;
      index = (i % items.length + items.length) % items.length;
      var w = viewport.offsetWidth;
      track.style.transform = 'translateX(-' + (index * w) + 'px)';
    }

    function nextSlide() { goTo(index + 1); }
    function prevSlide() { goTo(index - 1); }
    function start() { stop(); timer = setInterval(nextSlide, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function handleNext(e) {
      e.preventDefault();
      e.stopPropagation();
      nextSlide();
      start();
    }

    function handlePrev(e) {
      e.preventDefault();
      e.stopPropagation();
      prevSlide();
      start();
    }

    // Button events
    if (next) {
      next.addEventListener('click', handleNext);
      next.addEventListener('touchend', handleNext, { passive: false });
    }
    if (prev) {
      prev.addEventListener('click', handlePrev);
      prev.addEventListener('touchend', handlePrev, { passive: false });
    }

    // Pause on hover/focus
    container.addEventListener('mouseenter', stop);
    container.addEventListener('mouseleave', start);
    container.addEventListener('focusin', stop);
    container.addEventListener('focusout', start);

    // Keyboard navigation
    container.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') { prevSlide(); start(); }
      else if (e.key === 'ArrowRight') { nextSlide(); start(); }
    });

    // Swipe support on viewport
    var touchStartX = 0;
    var touchEndX = 0;
    viewport.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      stop();
    }, { passive: true });

    viewport.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) { nextSlide(); } else { prevSlide(); }
      }
      start();
    }, { passive: true });

    // Resize handler
    window.addEventListener('resize', function() {
      setItemWidths();
      goTo(index);
    });

    // Init
    requestAnimationFrame(function() {
      setItemWidths();
      goTo(0);
      start();
    });
  }

  // Expose globally
  window.initVPBSlider = initVPBSlider;

  // Auto-init: cerca tutti i .vpb e li inizializza
  function autoInit() {
    var containers = document.querySelectorAll('.vpb[data-vpb-delay]');
    containers.forEach(function(container) {
      if (!container.dataset.vpbInitialized) {
        container.dataset.vpbInitialized = 'true';
        var delay = parseInt(container.dataset.vpbDelay) || 5000;
        initVPBSlider(container, { delay: delay });
      }
    });
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }
})();
